'use strict';

import 'angular';

import './style.css';
import boxDirective from './box';
import bodyDirective from './body';
import optionGroupDirective from './options/group';
import optionDirective from './options/option';
import optionBodyDirective from './options/body';
import optionSkipDirective from './options/skip';

var MODULE_NAME = 'daupler.incidents.components.actionBox';

var app = angular.module(MODULE_NAME, []);
app.directive('actionBox', boxDirective);
app.directive('actionBoxBody', bodyDirective);
app.directive('actionBoxOptionGroup', optionGroupDirective);
app.directive('actionBoxOption', optionDirective);
app.directive('actionBoxOptionBody', optionBodyDirective);
app.directive('actionBoxOptionSkip', optionSkipDirective);

export default MODULE_NAME;
